import React from "react";

/**
 * This will be the context of the application which we will use to create the global state
 */
export default React.createContext({});
